import { render } from "./CreateTeacherPassForm.vue?vue&type=template&id=f70188ea"
import script from "./CreateTeacherPassForm.vue?vue&type=script&lang=js"
export * from "./CreateTeacherPassForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__